import { createRecoilAtomKeys, defaultIsFirstVisit } from '@app/recoil';
import { atom } from 'recoil';

const parentGrouping = 'shared';

enum StateProps {
  isFirstVisit = 'isFirstVisit',
}

// Exported for testing
export const keys = createRecoilAtomKeys<typeof parentGrouping, StateProps>(
  parentGrouping,
  Object.values(StateProps),
);

export const isFirstVisitState = atom<boolean>({
  key: keys.shared.isFirstVisit.atom,
  default: defaultIsFirstVisit,
});
